import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.84 11.818h.75-.75zm3.031 1.705v.75-.75zM5 5v6.818h1.5V5H5zm0 6.818v7.068h1.5v-7.068H5zM14.09 5v6.818h1.5V5h-1.5zm0 6.818v7.068h1.5v-7.068h-1.5zm-8.34.75h9.09v-1.5H5.75v1.5zm11.75 1.334v4.984H19v-4.984h-1.5zm-.954.37h1.325v-1.5h-1.326v1.5zm2.454-.37a1.13 1.13 0 00-1.129-1.13v1.5a.371.371 0 01-.371-.37H19z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.75 12h.75-.75zm4 2.25V15v-.75zM3 3v9h1.5V3H3zm0 9v9h1.5v-9H3zm12-9v9h1.5V3H15zm0 9v9h1.5v-9H15zm-11.25.75h12v-1.5h-12v1.5zm15.75 2V21H21v-6.25h-1.5zM18 15h1.75v-1.5H18V15zm3-.25c0-.69-.56-1.25-1.25-1.25V15a.25.25 0 01-.25-.25H21z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.5 24H33h-1.5zm8 4.5V30v-1.5zM6 6v18h3V6H6zm0 18v18h3V24H6zM30 6v18h3V6h-3zm0 18v18h3V24h-3zM7.5 25.5h24v-3h-24v3zm31.5 4V42h3V29.5h-3zm-3 .5h3.5v-3H36v3zm6-.5a2.5 2.5 0 00-2.5-2.5v3a.5.5 0 01-.5-.5h3z"
  }))
};
export var Heading = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});